export const useIsDemo = () => {
	return useNuxtApp().$isDemo;
};
